import { Box, Container, Typography, Grid } from '@mui/material';
import { Email, Phone } from '@mui/icons-material';

function Footer() {
  return (
    <Box component="footer" sx={{ background: 'linear-gradient(45deg, #00E676 30%, #0288D1 90%)', color: '#ffffff', py: 6, mt: 'auto' }}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#ffffff', fontWeight: 'bold' }}>
              Pierre Brothers Tech
            </Typography>
            <Typography variant="body2" sx={{ color: '#ffffff' }}>
              Delivering innovative technology solutions for tomorrow's challenges
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#ffffff', fontWeight: 'bold' }}>
              Contact Information
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Email sx={{ mr: 1, fontSize: 20, color: '#ffffff' }} />
              <Typography variant="body2" sx={{ color: '#ffffff' }}>contact@pierrebrotherstech.com</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Phone sx={{ mr: 1, fontSize: 20, color: '#ffffff' }} />
              <Typography variant="body2" sx={{ color: '#ffffff' }}>+1 (678) 830-2133</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#ffffff', fontWeight: 'bold' }}>
              Services
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.5, color: '#ffffff' }}>Custom Software Development</Typography>
            <Typography variant="body2" sx={{ color: '#ffffff' }}>IT Consulting</Typography>
          </Grid>
        </Grid>
        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.2)', mt: 4, pt: 3 }}>
          <Typography variant="body2" align="center" sx={{ color: '#ffffff' }}>
            © {new Date().getFullYear()} Pierre Brothers Tech. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
